import { AlertTriangle, MonitorDown, Package } from "lucide-react";
import { Reveal } from "@/components/motion";

export const Requirements = () => (
  <section id="requirements" className="border-y border-white/10 bg-[#0A0A0A]" data-testid="requirements">
    <div className="px-6 sm:px-12 lg:px-20 py-24 max-w-[1400px] mx-auto">
      <Reveal>
        <p className="label-mono mb-4 flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-[#FF3B00]" /> 02 — Before you install
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]">
          System requirements
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-12 border border-white/10 bg-black" data-testid="terminal-window">
          <div className="flex items-center gap-2 border-b border-white/10 px-4 py-3">
            <span className="w-2.5 h-2.5 rounded-full bg-[#FF3B00]" />
            <span className="w-2.5 h-2.5 rounded-full bg-[#F5A623]" />
            <span className="w-2.5 h-2.5 rounded-full bg-[#00FF41]" />
            <span className="ml-3 font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/40">install_notes.txt</span>
          </div>
          <div className="p-6 sm:p-8 font-mono2 text-sm leading-loose space-y-1">
            <p className="text-white/40">C:\&gt; type install_notes.txt</p>
            <p className="text-white/80">&gt; OS ......... Windows 10 / 11 (64-bit)</p>
            <p className="text-white/80">&gt; RUNTIME .... Microsoft Visual C++ Redistributable (x64)</p>
            <p className="text-white/80">&gt; DISK ....... ~40 MB</p>
            <p className="text-white/80">&gt; ACCOUNT .... none — runs fully offline</p>
          </div>
        </div>
      </Reveal>

      <div className="mt-4 grid md:grid-cols-2 gap-4">
        <Reveal delay={0.2}>
          <div className="border border-[#F5A623]/50 bg-[#F5A623]/5 p-8 h-full" data-testid="windows-warning">
            <div className="flex items-center gap-3 mb-4">
              <AlertTriangle className="w-5 h-5 text-[#F5A623]" />
              <h3 className="font-display uppercase tracking-tight text-xl text-[#F5A623]">Windows only</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              CNCroutersoft is a native Windows desktop application. It will <span className="text-white font-medium">not</span> run
              on macOS or Linux — no VM, Wine, or dual-boot support is provided. If you're not on Windows,
              save your inbox the trouble.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="grid-cell p-8 h-full" data-testid="cpp-redist-note">
            <div className="flex items-center gap-3 mb-4">
              <Package className="w-5 h-5 text-[#FF3B00]" />
              <h3 className="font-display uppercase tracking-tight text-xl">C++ Redistributable required</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              If ShapeEditor.exe refuses to start, install the{" "}
              <span className="text-white font-medium">Microsoft Visual C++ Redistributable (x64)</span> from
              Microsoft's official site, then relaunch. It's a one-time, two-minute fix.
            </p>
            <p className="mt-4 font-mono2 text-[11px] text-white/35 uppercase tracking-[0.2em] flex items-center gap-2">
              <MonitorDown className="w-3.5 h-3.5" /> Search: "Visual C++ Redistributable latest x64"
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
